import { useMemo, useRef, useState } from 'react';
import { ReactSimpleComponentProps } from '@/custom-types';
import { AddSupplierFormModalContext, AddSupplierFormModalContextProps } from './AddSupplierFormModalContext';
import { SetSuppliertToIncidentInput } from '@/graphql/generated';

export const AddSupplierFormModalContextProvider = ({ children }: ReactSimpleComponentProps) => {
  const supplierDataRef = useRef<SetSuppliertToIncidentInput | null>(null)
  const [isOpen, setOpen] = useState(false)

  const actions = useMemo<Omit<AddSupplierFormModalContextProps, 'supplierData' | 'isOpen'>>(() => ({
    closeModal: () => {
      setOpen(false)
      supplierDataRef.current = null
    },

    openModal: (supplierData?: SetSuppliertToIncidentInput) => {
      setOpen(true)

      if (supplierData) supplierDataRef.current = supplierData
    },
  }), [])

  return (
    <AddSupplierFormModalContext.Provider value={{ ...actions, isOpen, supplierData: supplierDataRef.current}}>
      {children}
    </AddSupplierFormModalContext.Provider>
  )
}